import React from "react"
import { Modal, Button } from "react-bootstrap"

const WarningModal = ({ show, handleClose, message }) => {
    return (
        <Modal
            show={show}
            onHide={handleClose}
            backdrop="static"
            keyboard={false}>
            <Modal.Header closeButton>
                <Modal.Title>Warning</Modal.Title>
            </Modal.Header>
            <Modal.Body>{message}</Modal.Body>
            <Modal.Footer>
                <Button
                    variant="primary"
                    onClick={handleClose}>
                    OK
                </Button>
            </Modal.Footer>
        </Modal>
    )
}

export default WarningModal
